import { request, useMutation } from '~reactQuery';

import { WalletData } from '~reactQuery/types/business.types';
import { gql } from 'graphql-request';
import { useQueryClient } from 'react-query';

interface WalletsModifyInput {
  walletAddress: string;
  name: string;
  data: WalletData;
  owner?: number;
  userOrganizationId: number;
}

interface WalletsModifyResponse {
  walletsModify: boolean;
}

export function useWalletsModify() {
  const queryClient = useQueryClient();

  const mutation = gql`
    mutation WalletsModify($params: WalletsModifyInput!) {
      walletsModify(params: $params)
    }
  `;

  const fetch = async (params: WalletsModifyInput) => {
    const response = await request<WalletsModifyResponse>(mutation, {
      params,
    });
    return response.walletsModify;
  };

  return useMutation('WalletsModify', fetch, {
    onSuccess: () => {
      setTimeout(() => queryClient.invalidateQueries(['getWallets']), 1000);
    },
  });
}
